
import React from 'react'
import { Link } from 'react-router-dom'

import './HeaderMainMenuItem.scss'

interface Props {
  icon: string | JSX.Element
  text: string
  path?: string
  active: boolean
  disabled?: boolean
}

const HeaderMainMenuItem = ({ icon, text, path, active, disabled }: Props) => {

  return (
    <li className='header-main-menu-item'>
      {disabled && (
        <span className="svg-icon-menu cursor-pointer">
          <div className="svg-icon">
            <div className="svg-icon-container">
              <span className={`main-menu-icon ${icon}${active ? '_full' : ''}`}></span>
            </div>
          </div>
          <span className={`svg-icon-textx`}>
            {text}
          </span>
        </span>
      )}
      {!disabled && path && (
        <Link
          className={`svg-icon-menu ${active && 'active'}`}
          to={path}
        >
          <div className="svg-icon">
            <div className="svg-icon-container">
              <span className={`main-menu-icon ${icon}${active ? '_full' : ''}`}></span>
            </div>
          </div>
          <span className={`svg-icon-texts`}>
            {text}
          </span>
        </Link>
      )}
    </li>
  )
}

export default HeaderMainMenuItem
